module.exports = __webpack_public_path__ + "LatoLatin-Italic.6df64ed5a283ba37d653.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.eot
// module chunks = styles